import { render, staticRenderFns } from "./VisitorsFaq.vue?vue&type=template&id=5b13ba9e"
import script from "./VisitorsFaq.vue?vue&type=script&lang=js"
export * from "./VisitorsFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports